$(function() {
  $('.go-back').on('click', function() {
    window.history.back()
    return false
  })
})
